import { choose } from '../../utils/platform';
import CostLinesBreakdownDesktop from './CostLinesBreakdown.desktop';
import CostLinesBreakdownMobile from './CostLinesBreakdown.mobile';

export default choose(CostLinesBreakdownDesktop, CostLinesBreakdownMobile);
